<template>
    <div :id="`gallery-${galleryId}`">
        <slot :open="open"></slot>
    </div>
</template>

<script>
import(
    /* webpackChunkName: "lx-photoswipe-css" */ 'photoswipe/style.css'
);

export default {
    name: 'Photoswipe',
    props: {
        galleryId: {
            type: String,
            required: true,
        },
        dataSource: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            lightbox: null,
        };
    },
    methods: {
        open(index) {
            if (this.lightbox) {
                this.lightbox.loadAndOpen(index);
            }
        }
    },
    mounted() {
        if (!this.lightbox) {
            const galleryEl = document.querySelector(
                `#gallery-${this.galleryId}`
            );
            import(
                /* webpackChunkName: "lx-photoswipe-lightbox" */ 'photoswipe/lightbox'
            ).then((lightbox) => {
                const PhotoSwipeLightbox = lightbox.default;
                this.lightbox = new PhotoSwipeLightbox({
                    dataSource: this.dataSource,
                    pswpModule: () =>
                        import(
                            /* webpackChunkName: "lx-photoswipe" */ 'photoswipe'
                        ),
                    wheelToZoom: true,
                });
                this.lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
                    const el = galleryEl.querySelector(
                        '[data-id="' + data.id + '"] img'
                    );
                    if (el) return el;
                    return thumbEl;
                });
                this.lightbox.addFilter(
                    'placeholderSrc',
                    (placeholderSrc, slide) => {
                        const el = galleryEl.querySelector(
                            '[data-id="' + slide.data.id + '"] img'
                        );
                        if (el) return el.src;
                        return placeholderSrc;
                    }
                );
                this.lightbox.on('uiRegister', () => {
                    this.lightbox.pswp.ui.registerElement({
                        name: 'custom-caption',
                        order: 9,
                        isButton: false,
                        appendTo: 'wrapper',
                        html: 'Caption text',
                        onInit: (el, pswp) => {
                            el.setAttribute(this.$options._scopeId, "");
                            pswp.on('change', () => {
                                const caption = pswp.currSlide.data.alt;
                                if (caption) {
                                    el.textContent = caption
                                    el.classList.remove('hidden')
                                } else {
                                    el.textContent = ''
                                    el.classList.add('hidden')
                                }
                            });
                        }
                    });
                });
                this.lightbox.init();
            });
        }
    },
    unmounted() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
        }
    },
};
</script>

<style lang="scss" scoped>
    .pswp__custom-caption {
        background: rgba(13, 71, 161, 0.75);
        font-size: 16px;
        color: #fff;
        width: calc(100% - 32px);
        max-width: 400px;
        padding: 7px 14px;
        border-radius: 4px;
        position: absolute;
        left: 50%;
        bottom: 16px;
        transform: translateX(-50%);
    }
    .pswp__custom-caption a {
        color: #fff;
        text-decoration: underline;
    }
    .pswp__custom-caption.hidden {
        display: none;
    }
</style>
